/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminCancelReservedNotificationConflictDto } from '../../src/model';
// @ts-ignore
import type { AdminCancelReservedNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminCancelReservedNotificationNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminCancelReservedNotificationOkDto } from '../../src/model';
// @ts-ignore
import type { AdminCancelReservedNotificationScheduledNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetNotificationOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSentNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetSentNotificationOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPostNotificationCreatedDto } from '../../src/model';
// @ts-ignore
import type { AdminPostNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPostNotificationNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPostNotificationReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPostReserveNotificationCreatedDto } from '../../src/model';
// @ts-ignore
import type { AdminPostReserveNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPostReserveNotificationReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateWithTargetUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminNotificationsApi - axios parameter creator
 * @export
 */
export const AdminNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 관리자 예약 알림 삭제
         * @param {string} notificationUuid 알림 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminCancelReservedNotification: async (notificationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationUuid' is not null or undefined
            assertParamExists('adminNotificationControllerAdminCancelReservedNotification', 'notificationUuid', notificationUuid)
            const localVarPath = `/admin/notifications/{notificationUuid}/reservation/cancel`
                .replace(`{${"notificationUuid"}}`, encodeURIComponent(String(notificationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 푸시 알림 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {any} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminGetNotification: async (page?: number, limit?: number, status?: any, startDate?: string, endDate?: string, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                for (const [key, value] of Object.entries(status)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알림 상세 조회
         * @param {string} notificationUuid 알림 uuid
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminNotificationControllerAdminGetSentNotificationsStatusEnum} [status] 수신 상태
         * @param {AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum} [sendCategory] 알림 전송 카테고리
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminGetSentNotifications: async (notificationUuid: string, page?: number, limit?: number, status?: AdminNotificationControllerAdminGetSentNotificationsStatusEnum, sendCategory?: AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationUuid' is not null or undefined
            assertParamExists('adminNotificationControllerAdminGetSentNotifications', 'notificationUuid', notificationUuid)
            const localVarPath = `/admin/notifications/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (notificationUuid !== undefined) {
                localVarQueryParameter['notificationUuid'] = notificationUuid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sendCategory !== undefined) {
                localVarQueryParameter['sendCategory'] = sendCategory;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 즉시 푸시 알림 생성
         * @param {AdminPostNotificationReqBodyDto} adminPostNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminPostNotification: async (adminPostNotificationReqBodyDto: AdminPostNotificationReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPostNotificationReqBodyDto' is not null or undefined
            assertParamExists('adminNotificationControllerAdminPostNotification', 'adminPostNotificationReqBodyDto', adminPostNotificationReqBodyDto)
            const localVarPath = `/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostNotificationReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 예약 푸시 알림 생성
         * @param {AdminPostReserveNotificationReqBodyDto} adminPostReserveNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminPostReserveNotification: async (adminPostReserveNotificationReqBodyDto: AdminPostReserveNotificationReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPostReserveNotificationReqBodyDto' is not null or undefined
            assertParamExists('adminNotificationControllerAdminPostReserveNotification', 'adminPostReserveNotificationReqBodyDto', adminPostReserveNotificationReqBodyDto)
            const localVarPath = `/admin/notifications/reservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostReserveNotificationReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationsApi - functional programming interface
 * @export
 */
export const AdminNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 관리자 예약 알림 삭제
         * @param {string} notificationUuid 알림 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationControllerAdminCancelReservedNotification(notificationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCancelReservedNotificationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationControllerAdminCancelReservedNotification(notificationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationsApi.adminNotificationControllerAdminCancelReservedNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 푸시 알림 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {any} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationControllerAdminGetNotification(page?: number, limit?: number, status?: any, startDate?: string, endDate?: string, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetNotificationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationControllerAdminGetNotification(page, limit, status, startDate, endDate, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationsApi.adminNotificationControllerAdminGetNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알림 상세 조회
         * @param {string} notificationUuid 알림 uuid
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminNotificationControllerAdminGetSentNotificationsStatusEnum} [status] 수신 상태
         * @param {AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum} [sendCategory] 알림 전송 카테고리
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationControllerAdminGetSentNotifications(notificationUuid: string, page?: number, limit?: number, status?: AdminNotificationControllerAdminGetSentNotificationsStatusEnum, sendCategory?: AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetSentNotificationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationControllerAdminGetSentNotifications(notificationUuid, page, limit, status, sendCategory, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationsApi.adminNotificationControllerAdminGetSentNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 즉시 푸시 알림 생성
         * @param {AdminPostNotificationReqBodyDto} adminPostNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationControllerAdminPostNotification(adminPostNotificationReqBodyDto: AdminPostNotificationReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPostNotificationCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationControllerAdminPostNotification(adminPostNotificationReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationsApi.adminNotificationControllerAdminPostNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 예약 푸시 알림 생성
         * @param {AdminPostReserveNotificationReqBodyDto} adminPostReserveNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationControllerAdminPostReserveNotification(adminPostReserveNotificationReqBodyDto: AdminPostReserveNotificationReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPostReserveNotificationCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationControllerAdminPostReserveNotification(adminPostReserveNotificationReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationsApi.adminNotificationControllerAdminPostReserveNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNotificationsApi - factory interface
 * @export
 */
export const AdminNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary 관리자 예약 알림 삭제
         * @param {AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminCancelReservedNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCancelReservedNotificationOkDto> {
            return localVarFp.adminNotificationControllerAdminCancelReservedNotification(requestParameters.notificationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 푸시 알림 조회
         * @param {AdminNotificationsApiAdminNotificationControllerAdminGetNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminGetNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminGetNotificationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetNotificationOkDto> {
            return localVarFp.adminNotificationControllerAdminGetNotification(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알림 상세 조회
         * @param {AdminNotificationsApiAdminNotificationControllerAdminGetSentNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminGetSentNotifications(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminGetSentNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetSentNotificationOkDto> {
            return localVarFp.adminNotificationControllerAdminGetSentNotifications(requestParameters.notificationUuid, requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.sendCategory, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 즉시 푸시 알림 생성
         * @param {AdminNotificationsApiAdminNotificationControllerAdminPostNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminPostNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminPostNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPostNotificationCreatedDto> {
            return localVarFp.adminNotificationControllerAdminPostNotification(requestParameters.adminPostNotificationReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 예약 푸시 알림 생성
         * @param {AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationControllerAdminPostReserveNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPostReserveNotificationCreatedDto> {
            return localVarFp.adminNotificationControllerAdminPostReserveNotification(requestParameters.adminPostReserveNotificationReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminNotificationControllerAdminCancelReservedNotification operation in AdminNotificationsApi.
 * @export
 * @interface AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotificationRequest
 */
export interface AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotificationRequest {
    /**
     * 알림 uuid
     * @type {string}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotification
     */
    readonly notificationUuid: string
}

/**
 * Request parameters for adminNotificationControllerAdminGetNotification operation in AdminNotificationsApi.
 * @export
 * @interface AdminNotificationsApiAdminNotificationControllerAdminGetNotificationRequest
 */
export interface AdminNotificationsApiAdminNotificationControllerAdminGetNotificationRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetNotification
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetNotification
     */
    readonly limit?: number

    /**
     * 알림 상태
     * @type {any}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetNotification
     */
    readonly status?: any

    /**
     * 시작 날짜
     * @type {string}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetNotification
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetNotification
     */
    readonly endDate?: string

    /**
     * 검색어
     * @type {string}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetNotification
     */
    readonly keyword?: string
}

/**
 * Request parameters for adminNotificationControllerAdminGetSentNotifications operation in AdminNotificationsApi.
 * @export
 * @interface AdminNotificationsApiAdminNotificationControllerAdminGetSentNotificationsRequest
 */
export interface AdminNotificationsApiAdminNotificationControllerAdminGetSentNotificationsRequest {
    /**
     * 알림 uuid
     * @type {string}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetSentNotifications
     */
    readonly notificationUuid: string

    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetSentNotifications
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetSentNotifications
     */
    readonly limit?: number

    /**
     * 수신 상태
     * @type {'checking' | 'success' | 'fail'}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetSentNotifications
     */
    readonly status?: AdminNotificationControllerAdminGetSentNotificationsStatusEnum

    /**
     * 알림 전송 카테고리
     * @type {'viewup' | 'sms'}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminGetSentNotifications
     */
    readonly sendCategory?: AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum
}

/**
 * Request parameters for adminNotificationControllerAdminPostNotification operation in AdminNotificationsApi.
 * @export
 * @interface AdminNotificationsApiAdminNotificationControllerAdminPostNotificationRequest
 */
export interface AdminNotificationsApiAdminNotificationControllerAdminPostNotificationRequest {
    /**
     * 
     * @type {AdminPostNotificationReqBodyDto}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminPostNotification
     */
    readonly adminPostNotificationReqBodyDto: AdminPostNotificationReqBodyDto
}

/**
 * Request parameters for adminNotificationControllerAdminPostReserveNotification operation in AdminNotificationsApi.
 * @export
 * @interface AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotificationRequest
 */
export interface AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotificationRequest {
    /**
     * 
     * @type {AdminPostReserveNotificationReqBodyDto}
     * @memberof AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotification
     */
    readonly adminPostReserveNotificationReqBodyDto: AdminPostReserveNotificationReqBodyDto
}

/**
 * AdminNotificationsApi - object-oriented interface
 * @export
 * @class AdminNotificationsApi
 * @extends {BaseAPI}
 */
export class AdminNotificationsApi extends BaseAPI {
    /**
     * 
     * @summary 관리자 예약 알림 삭제
     * @param {AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationControllerAdminCancelReservedNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminCancelReservedNotificationRequest, options?: RawAxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationControllerAdminCancelReservedNotification(requestParameters.notificationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 푸시 알림 조회
     * @param {AdminNotificationsApiAdminNotificationControllerAdminGetNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationControllerAdminGetNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminGetNotificationRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationControllerAdminGetNotification(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알림 상세 조회
     * @param {AdminNotificationsApiAdminNotificationControllerAdminGetSentNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationControllerAdminGetSentNotifications(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminGetSentNotificationsRequest, options?: RawAxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationControllerAdminGetSentNotifications(requestParameters.notificationUuid, requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.sendCategory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 즉시 푸시 알림 생성
     * @param {AdminNotificationsApiAdminNotificationControllerAdminPostNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationControllerAdminPostNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminPostNotificationRequest, options?: RawAxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationControllerAdminPostNotification(requestParameters.adminPostNotificationReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 예약 푸시 알림 생성
     * @param {AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationsApi
     */
    public adminNotificationControllerAdminPostReserveNotification(requestParameters: AdminNotificationsApiAdminNotificationControllerAdminPostReserveNotificationRequest, options?: RawAxiosRequestConfig) {
        return AdminNotificationsApiFp(this.configuration).adminNotificationControllerAdminPostReserveNotification(requestParameters.adminPostReserveNotificationReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminNotificationControllerAdminGetSentNotificationsStatusEnum = {
    Checking: 'checking',
    Success: 'success',
    Fail: 'fail'
} as const;
export type AdminNotificationControllerAdminGetSentNotificationsStatusEnum = typeof AdminNotificationControllerAdminGetSentNotificationsStatusEnum[keyof typeof AdminNotificationControllerAdminGetSentNotificationsStatusEnum];
/**
 * @export
 */
export const AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum = {
    Viewup: 'viewup',
    Sms: 'sms'
} as const;
export type AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum = typeof AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum[keyof typeof AdminNotificationControllerAdminGetSentNotificationsSendCategoryEnum];
